<template>
  <div class="preview-record">
    <p class="preview-record__subtitle">* 仅展示老师自己任教的年级、班级</p>
    <div>
      <div class="s-form-item">
        <span class="s-form-item__label">所属年级：</span>
        <div class="s-form-item__hidden" ref="AllGrade">
          <div ref="grade" id="grade" style="position: relative;top: -12px;">
            <span :class="getClass('grade', '')" class="s-form-item__text pointer"
              @click="onChange('grade', '')"> 全部 </span>
            <span
            class="dot-span pointer"
            :class="getClass('grade', item.academic_year_id)"
            v-for="item in gradeList"
            :key="item.academic_year_id"
            @click="onChange('grade', item)"
          >{{item.name}}</span>
          </div>
        </div>
        <span class="s-form-item__label blue pointer" v-if="!unfoldGrade && unfoldGradeShow"
        @click="unfold('grade')"> 展开
          <i class="el-icon-caret-bottom"></i>
        </span>
        <span class="s-form-item__label blue pointer" v-if="!unfoldGrade && !unfoldGradeShow"
        @click="packUp('grade')"> 收起
          <i class="el-icon-caret-top"></i>
        </span>
      </div>
      <div class="s-form-item">
        <span class="s-form-item__label">所属班级：</span>
        <div class="s-form-item__hidden" ref="AllClass">
          <div ref="class" style="position: relative;top: -12px">
            <span :class="getClass('class', '')" class="s-form-item__text pointer"
            @click="onChange('class', '')"> 全部 </span>
            <span
              class="dot-span pointer"
              :class="getClass('class', item.id)"
              v-for="item in classList"
              :key="item.id"
              @click="onChange('class', item)"
            >{{item.name}}</span>
          </div>
        </div>
        <span class="s-form-item__label blue pointer" v-if="!unfoldClass && unfoldClassShow"
        @click="unfold('class')"> 展开
          <i class="el-icon-caret-bottom"></i>
        </span>
        <span class="s-form-item__label blue pointer" v-if="!unfoldClass && !unfoldClassShow"
        @click="packUp('class')"> 收起
          <i class="el-icon-caret-top"></i>
        </span>
      </div>
      <!-- <div class="s-form-item">
        <span class="s-form-item__label">所属学科：</span>
        <div>
          <span
            :class="getClass('subject', '')"
            @click="onChange('subject', '')"
            >全部</span
          >
          <span
            class="dot-span"
            :class="getClass('subject', item.id)"
            v-for="item in sortedSubjectList"
            :key="item.id"
            @click="onChange('subject', item)"
            >{{ item.name }}</span
          >
        </div>
      </div> -->
    </div>
    <footer class="search-footer" v-if="testList.length">
      <p class="search-footer__title">预习任务</p>
      <div>
        <el-input
          placeholder="请输入预习名称"
          clearable
          v-model="searchForm.testName"
        ></el-input>
        <el-button type="primary" @click="onSearchClick">查询</el-button>
      </div>
    </footer>
    <Empty v-if="gradeList.length < 1"
    content="暂未获取到您任教的年级、班级信息,"
    lastContent="请联系校区管理员设置" :show="false" />
    <!-- 列表展示 -->
    <ul class="test-record-list" v-if="testList.length > 0">
      <li
        v-for="(items, index) in testList"
        :key="index"
        class="test-record-list__item"
      >
        <div class="test-record-list__item__head">
          <p class="head__left">
            <span
              class="head__left__subject"
              :style="{ backgroundColor: colorList[items.subject_id] }"
            >
              {{ items.subject_name }}
            </span>
            <span>
              {{ items.evaluate_name }}
            </span>
          </p>
          <p class="head__right">
            <span> 布置时间:{{ items.created }} </span>
            <span> 创建人:{{ items.teacher_name }} </span>
            <span
              class="head__right__delete"
              v-if="items.eva_list.length > 1 && canDelete"
              @click="onDeleteClick(items, index, testList)"
            >
              全部删除
            </span>
          </p>
        </div>
        <div
          class="test-record-list__item__body"
          v-for="(item, index) in items.eva_list"
          :key="index"
        >
          <p class="body__left">
            <span class="body__left__className">
              {{ item.class_name }}
            </span>
            完成人数:
            <span>{{ item.finish_stu }}</span
            >/<span>{{ item.total_stu }}</span>
          </p>
          <p class="body__right">
            <span class="body__right__look" @click="goReport(items, item)"
              >查看报告</span
            >
            <span
              class="body__right__delete"
              v-if="canDelete"
              @click="onDeleteClick(item, index, items.eva_list)"
              >删除</span
            >
          </p>
        </div>
        <img src="../../images/lower_left.png" class="lower-left" />
      </li>
    </ul>
    <Empty v-if="!testList.length && gradeList.length > 0"
        content="当前搜索条件下没有找到任何预习,"
        lastContent="换个条件试试吧" />
    <!-- 分页 -->
    <el-pagination
      v-if="testList.length"
      background
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      :page-size.sync="pageSize"
      :page-sizes="[10, 50, 100]"
      :current-page.sync="currentPage"
    >
    </el-pagination>
  </div>
</template>

<script>
import {
  getEvaluateList, getTeacherClass, getTeacherYear, deleteEvaluate,
} from '@/api/pt';
import { getSign } from '@/utils/verify';
import { unlocking } from '@/utils/access-control';
import { RECORD_DELETE } from '@/utils/access-code';
import mixins from '../../mixins';
import Empty from '@/views/pt/components/empty.vue';

const descending = 0;
const TEACHER_ROLE = 6008003;
// const TOB = 1; // 渠道 1 tob 2运营平台
export default {
  name: 'PreviewRecord',
  components: {
    Empty,
  },
  mixins: [mixins],
  data() {
    const userInfo = JSON.parse(localStorage.getItem('CRM_USER_INFO')) || {};
    return {
      isPad: this.$route.query.spad,
      searchForm: {
        grade: '',
        subject: '',
        class: '',
        version: '',
        stage: '',
        course: '',
        testName: '',
        sortBy: 'created',
        order: descending,
      },
      // 配色列表
      colorList: {
        1: '#FF8D27', // 英语
        2: '#0DD4C8', // 数学
        3: '#FF8D27', // 语文
        4: '#27ACFF', // 物理
        5: '#9962F8', // 化学
      },
      total: 0, // 总数
      pageSize: 10,
      currentPage: 1,
      // 测试内容年级（阶段）列表
      stageList: [],
      // 可选科目
      subjectList: [],
      // 可选版本
      versionList: [],
      // 可选年级
      gradeList: [],
      // 可选班级
      classList: [],
      // 可选课程
      courseList: [],
      // 测评列表
      testList: [],
      evaList: [],
      unfoldGradeShow: true,
      unfoldClassShow: true,
      unfoldClass: false,
      unfoldGrade: false,
      emptyShow: false,
      isTeacher: userInfo.position === TEACHER_ROLE,
      canDelete: unlocking(RECORD_DELETE),
    };
  },
  computed: {
    visibleTestSearch() {
      return !!this.searchForm.class;
    },
    visibleGradeSearch() {
      return !!this.gradeList.length;
    },
    sortedSubjectList() {
      if (!this.subjectList || !this.subjectList.length) {
        return [];
      }
      return this.subjectList.map((item) => item).sort((a, b) => a.id - b.id);
    },
  },
  watch: {
    gradeList() {
      this.$nextTick(() => {
        if (this.$refs.grade && this.$refs.grade.offsetHeight < 70) {
          console.log(3);
          this.unfoldGrade = true;
        } else {
          console.log(4);
          this.unfoldGrade = false;
        }
      });
    },
    classList() {
      this.$nextTick(() => {
        if (this.$refs.class && this.$refs.class.offsetHeight < 70) {
          this.unfoldClass = true;
        } else {
          this.unfoldClass = false;
        }
      });
    },
    currentPage() {
      this.getEvaluateList();
    },
    pageSize() {
      this.getEvaluateList();
    },
    'searchForm.grade': {
      immediate: true,
      handler(v) {
        if (this.isPad) {
          return;
        }
        getTeacherClass({
          id: (v && v.academic_year_id) || '',
        }).then((res) => {
          if (res.code === 200) {
            this.classList = res.data;
          }
        });
      },
    },
    searchForm: {
      deep: true,
      handler() {
        this.getEvaluateList();
      },
    },
  },
  activated() {
    console.log('activatee');
  },
  mounted() {
    console.log('mounted');
    this.initData();
    this.getEvaluateList();
  },
  methods: {
    unfold(type) {
      if (type === 'grade') {
        this.unfoldGradeShow = false;
        console.log(this.$refs.grade.offsetHeight);
        this.$refs.AllGrade.style.height = `${this.$refs.grade.offsetHeight}px`;
      }
      if (type === 'class') {
        console.log(this.$refs.class.offsetHeight);
        this.unfoldClassShow = false;
        this.$refs.AllClass.style.height = `${this.$refs.class.offsetHeight}px`;
      }
    },
    packUp(type) {
      if (type === 'grade') {
        this.unfoldGradeShow = true;
        this.$refs.AllGrade.style.height = '42px';
      }
      if (type === 'class') {
        this.unfoldClassShow = true;
        this.$refs.AllClass.style.height = '42px';
      }
    },
    onSizeChange(v) {
      this.pageSize = v;
      if (this.currentPage === 1) {
        this.getEvaluateList();
      } else {
        this.currentPage = 1;
      }
    },
    initData() {
      if (this.isPad) {
        return;
      }
      // 年级、班级
      getTeacherYear().then((res) => {
        if (res.code === 200) {
          this.gradeList = res.data;
        }
      });
      // 选课列表
      const typeList = ['subjects'];
      typeList.forEach((type) => {
        this.getCategory({ type, ...this.searchForm[type] });
      });
    },
    isCurrent(type, value) {
      if (!this.searchForm[type]) {
        return !value;
      }
      if (type === 'grade') {
        return this.searchForm.grade.academic_year_id === value;
      }
      return this.searchForm[type].id === value;
    },
    getClass(type, value) {
      return this.isCurrent(type, value) ? 'is-blue' : '';
    },
    onChange(type, item) {
      this.searchForm[type] = item;
    },
    onSearchClick() {
      this.getEvaluateList();
    },
    async getEvaluateList() {
      const userInfo = JSON.parse(localStorage.getItem('CRM_USER_INFO')) || {};
      const data = {
        // re_from: TOB,
        school_id: userInfo.campusId,
        teacher_id: userInfo.id,
        role_id: userInfo.position,
        school_year: this.searchForm.grade.name || '',
        grade_id: this.searchForm.grade.id || '',
        class_id: this.searchForm.class.id || '',
        evaluate_name: this.searchForm.testName || '',
        subject_id: this.searchForm.subject.id || '',
        textbook_id: this.searchForm.version.id || '',
        test_grade_id: this.searchForm.stage.id || '',
        test_id: this.searchForm.course.id || '',
        page_size: this.pageSize,
        curr_page: this.currentPage,
        sort: this.searchForm.order,
        type: 2, // 1测评中心 2预习
      };
      await getEvaluateList({
        ...data,
        sign: getSign(data),
      }).then((res) => {
        if (res.code === 200) {
          this.testList = res.data.list;
          this.total = res.data.total;
        }
      });
    },
    // 跳转预习知识点班级报告
    goReport(items, item) {
      this.$router.push({
        path: '/pt/lesson-prepare/class-report-detail',
        query: {
          batchId: items.batch_id,
          subjectId: items.subject_id,
          evaluateId: item.evaluate_id,
          classId: item.class_id,
          className: item.class_name,
        },
      });
    },
    // 删除预习报告
    onDeleteClick(item, index, list) {
      this.$confirm('<p style="color:#F56C6C;">一经确认，预习将被删除，已完成的学生数据也将删除</p>', '确认要删除此次预习吗？', {
        center: true,
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        customClass: 'i-confirm',
        dangerouslyUseHTMLString: true,
      }).then(() => {
        this.deleteEvaluate(item, index, list);
      }).catch(() => {
        console.log('取消');
      });
    },
    async deleteEvaluate(item, index, list) {
      const id = item.batch_id || item.evaluate_id;
      // 删除批次 or 单个测评
      const type = item.batch_id ? 1 : 2;
      const userInfo = JSON.parse(localStorage.getItem('CRM_USER_INFO')) || {};
      await deleteEvaluate({
        school_id: userInfo.campusId,
        teacher_id: userInfo.id,
        delete_type: type,
        id,
      }).then((res) => {
        console.log(res);
        if (res.code === 200 && res.data) {
          this.$message.success('删除成功');
          if (type === 1) {
            this.getEvaluateList();
          }
          if (type === 2) {
            list.splice(index, 1);
            if (list.length === 0) {
              this.getEvaluateList();
            }
          }
        } else {
          this.$message.error('删除失败');
        }
      }).catch(() => {
        this.$message.error('删除失败');
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.preview-record {
  padding: 0px 17px 100px;
  min-height: 100%;
  box-sizing: border-box;
  overflow-y: auto;
  background: #fff;
  position: relative;
  &__subtitle {
    color: rgba(144, 147, 153, 1);
    font-size: 14px;
  }
  .empty-img {
    width: 160px;
  }
  .search-footer {
    margin-top: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: rgba(48, 49, 51, 0.6);
    font-size: 14px;
    .search-footer__title {
      height: 38px;
      line-height: 38px;
      font-size: 17px;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.8);
      background: url("../../images/class_bg.png") no-repeat;
      background-size: 38px 29px;
    }
    .el-button {
      border-radius: 0 4px 4px 0;
    }
    .el-input {
      width: 328px;
      vertical-align: bottom;
      /deep/ .el-input__inner {
        border-radius: 4px 0 0 4px;
      }
    }
  }
  .test-record-list {
    &__item {
      font-size: 14px;
      color: rgba(17, 31, 44, 0.6);
      padding: 25px 24px 29px;
      border: 4px solid rgba(118, 194, 255, 0.14);
      border-radius: 12px;
      margin-top: 23px;
      background: url("../../images/lower_right.png") no-repeat right bottom;
      position: relative;
      span {
        display: inline-block;
      }
      img {
        position: absolute;
      }
      .lower-left {
        bottom: -1px;
        left: -1px;
      }
      &__head {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .head__left {
          font-size: 16px;
          line-height: 22px;
          color: #111f2c;
          &__subject {
            color: #ffffff;
            border-radius: 6px;
            width: 43px;
            height: 24px;
            text-align: center;
            line-height: 24px;
            margin-right: 8px;
          }
        }
        .head__right {
          span {
            margin-left: 10px;
          }
          &__delete {
            margin-left: 42px;
            text-align: center;
            line-height: 32px;
            width: 100px;
            height: 32px;
            border-radius: 4px;
            border: 1px solid #dcdfe6;
            cursor: pointer;
          }
        }
      }
      &__body {
        margin-top: 27px;
        display: flex;
        justify-content: space-between;
        .body__left {
          &__className {
            padding-right: 35px;
          }
        }
        .body__right {
          span {
            margin-left: 32px;
            cursor: pointer;
          }
          &__look {
            font-size: 15px;
            color: #2194ff;
            text-decoration: underline;
          }
          &__delete {
            font-size: 15px;
            color: rgba(48, 49, 51, 0.8);
          }
        }
      }
    }
  }
  .no-test-record-list {
    margin-top: 78px;
    min-height: 500px;
    text-align: center;
    img {
      width: 209px;
      height: 147px;
    }
  }
  .s-lg {
    width: 120px;
    height: 40px;
  }
  /deep/ .el-pagination {
    display: flex;
    position: absolute;
    width: calc(100% - 64px);
    bottom: 30px;
    left: 32px;
    .btn-prev {
      margin-left: auto;
    }
  }
  .search-tip {
    display: block;
    margin: -10px 0 0;
    width: 434px;
  }
  .s-form-item {
    line-height: 42px;
    font-size: 14px;
    display: flex;
    padding: 20px 0;
    &:not(:last-of-type) {
      border-bottom: 1px dashed rgba(220, 225, 235, 1);
    }
    &__text {
      margin-right: 30px;
      line-height: 24px;
      padding: 7px 12px;
      &:hover {
        color: rgba(25, 137, 250, 1);
      }
    }
    &__hidden {
      overflow: hidden;
      height: 42px;
    }
    &__label {
      color: rgba(0, 0, 0, 1);
      font-weight: 400;
      font-size: 16px;
      width: 104px;
      min-width: 104px;
    }
    .blue {
      color: rgba(25, 137, 250, 1);
    }
    .is-blue {
      border-radius: 5px;
      background-color: rgba(25, 137, 250, 1);
      color: #fff;
      font-weight: 500;
      &:hover {
        color: #fff !important;
      }
    }
    .dot-span {
      padding: 7px 12px;
      box-sizing: border-box;
      // padding-left: 20px;
      display: inline-block;
      line-height: 24px;
      position: relative;
      margin-right: 30px;
      margin-top: 16px;
      white-space: nowrap;
      &:hover {
        color: rgba(25, 137, 250, 1);
      }
    }
  }
  .el-pagination {
    left: 17px;
    width: calc(100% - 41px);
    padding-right: 17px;
  }
}
</style>
